import { render } from "./ATS.vue?vue&type=template&id=ac06f5f0&scoped=true"
import script from "./ATS.vue?vue&type=script&lang=js"
export * from "./ATS.vue?vue&type=script&lang=js"

import "./ATS.vue?vue&type=style&index=0&id=ac06f5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac06f5f0"]])

export default __exports__